<template>
  <div class="page-content-wrapper">
    <div class="content">
      <div class="container-fluid container-fixed-lg">
        <div class="row p-3">
          <div class="col-lg-12">
            <h2 class="text-dag">{{ $t('menu_info') }}</h2>
          </div>
        </div>
        <div class="row p-3">
          <div class="col-lg-3 m-b-10"
               v-for="info in getInfo">
            <div class="card no-border widget-loader-circle no-padding rounded h-100">
              <router-link class="card-link-24"
                           :to="{ name: 'infopage', params: { info_id: info.Id} }">
                <div class="card-header"
                     :class="getShiftClass.box[0]">
                </div>
                <div class="card-body text-center p-t-20 p-b-30">
                  <div class="card-icon"
                       v-if="info.Image">
                    <img :src="require(`@/assets/img/Food icons/${info.Image}`)" width="100">
                  </div>
                  <div class="card-link card-link-24"
                       :class="getShiftClass.td[0]">
                    {{ info.Title }}
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { mapActions } from 'vuex'

  export default {
    computed: {
      ...mapGetters([
        'getShiftClass',
        'getInfo',
      ]),
    },
    data() {
      return {
      }
    },
    methods: {
      ...mapActions([
        'loadInfo',
      ]),
    },
    created() {
      this.loadInfo()
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/info/Info.vue